.insufficientCreditsContent {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0;
}
.addCreditsButton {
  width: 125px;
}

.upgradeButton {
  width: 100px;
}
